import { getPaths } from '@/routes'
import { connect } from 'react-redux'
import { Navigate, matchRoutes, useLocation } from 'react-router-dom'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

const mapStateToProps = ({ auth, account }) => ({
  token: auth.token,
  needChgPwd: auth.needChgPwd,
  permissions: account.permissions,
})

const isReportOnlyRole = permissions =>
  permissions.includes('emailCampaign_view') && !permissions.includes('emailCampaign_create')

const Redirect = ({ token, needChgPwd, permissions }) => {
  const location = useLocation()

  const matchedRoutes = matchRoutes(getPaths(), { pathname: location.pathname })
  const permission = get(matchedRoutes, '[0].route.permission')

  if (!token || needChgPwd) {
    return <Navigate to="/" replace />
  }

  if (permissions === null) {
    return null
  }

  if (location.pathname === '/home' && isReportOnlyRole(permissions)) {
    return <Navigate to="/user_management" replace />
  }

  if (!isEmpty(permission) && !permissions.includes(permission)) {
    return <Navigate to="/" replace />
  }

  return null
}

export default connect(mapStateToProps)(Redirect)
